module.exports = __webpack_public_path__ + "static/media/logo-xmas.d9cc31bb.svg";